import { render } from "./page-mortgagemrc.vue?vue&type=template&id=bf47256a"
import script from "./page-mortgagemrc.js?vue&type=script&lang=js"
export * from "./page-mortgagemrc.js?vue&type=script&lang=js"

import "./page-mortgagemrc.vue?vue&type=style&index=0&id=bf47256a&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__